export const TWO_HOURS = 12 * 60 * 1000;
